import React from 'react'
import { Stack } from 'react-bootstrap'
import type { ShortcutConfig } from '@ztechapps/webui.util'
import { blogPermissions } from '@ztechapps/blog.common'
import { Page } from '@ztechapps/webui.page'
import { HorizontalStack } from '@ztechapps/webui.util'
import { BlogListProvider } from './Context'
import { Layout } from './Layout'
import { Toolbox } from './Toolbox'

export type BlogListProps = {
  /** The host's Refresh shortcut entry — registered against the list's refetch. */
  refreshShortcut: ShortcutConfig
}

export const BlogList = ({ refreshShortcut }: BlogListProps) => (
  <BlogListProvider>
    <Page roleName={blogPermissions.canView.value}>
      <Stack gap={3}>
        <HorizontalStack gap={2}>
          <Toolbox refreshShortcut={refreshShortcut} />
        </HorizontalStack>
        <div>
          <Layout />
        </div>
      </Stack>
    </Page>
  </BlogListProvider>
)
